import DxmlText from "../DxmlText"
import DxmlTable from "../DxmlTable"
import DxmlBreakTable from "../DxmlBreakTable"
import DxmlTextPart from "../DxmlTextPart"
import DxmlTextChoice from "../DxmlTextChoice"
import DxmlInsertPoint from "../DxmlInsertPoint"
import DxmlImage from "../DxmlImage"
import DxmlHeightSpace from "../DxmlHeightSpace"
import DxmlSvg from "../DxmlSvg"
import * as Constants from "../../../../../utils/constants"

export default function DxmlElement({ editorBaseModel }) {
    if (editorBaseModel.Type === Constants.editorType.text) {
        return <DxmlText editorText={editorBaseModel}></DxmlText>
    }

    if (editorBaseModel.Type === Constants.editorType.table) {
        return <DxmlTable editorTable={editorBaseModel}></DxmlTable>
    }

    if (editorBaseModel.Type === Constants.editorType.breakTable) {
        return <DxmlBreakTable editorBreakTable={editorBaseModel}></DxmlBreakTable>
    }

    if (editorBaseModel.Type === Constants.editorType.textPart) {
        return <DxmlTextPart editorTextPart={editorBaseModel}></DxmlTextPart>
    }

    if (editorBaseModel.Type === Constants.editorType.textChoice) {
        return <DxmlTextChoice editorTextChoice={editorBaseModel}></DxmlTextChoice>
    }

    if (editorBaseModel.Type === Constants.editorType.image) {
        return <DxmlImage editorImage={editorBaseModel}></DxmlImage>
    }

    if (editorBaseModel.Type === Constants.editorType.insertPoint) {
        return <DxmlInsertPoint editorInsertPoint={editorBaseModel}></DxmlInsertPoint>
    }

    // if (editorBaseModel.Type === Constants.editorType.heightSpace) {
    //     return <DxmlHeightSpace editorHeightSpace={editorBaseModel}></DxmlHeightSpace>
    // }

    if (editorBaseModel.Type === Constants.editorType.svg) {
        return <DxmlSvg editorSvg={editorBaseModel}></DxmlSvg>
    }

    return (
        <></>
    )
}